import { Route } from 'react-router-dom';
import { routes } from '../scripts/routes';

// This function returns the child routes for the video session so that the consuming app
// only needs to set up the parent route.
const getChildRoutes = (apiEnv, ssId) => (
	<>
		{routes.map(route => (
			<Route
				key={route.href}
				path={route.href}
				element={<route.component apiEnv={apiEnv} ssId={ssId} />}
			/>
		))}
	</>
);

export default getChildRoutes;
